<template>
  <div
    :class="[$style.base, { [$style.smallScreen]: isSmallScreen, [$style.inPackage]: inPackage }]"
  >
    <div :class="$style.service">
      <slot name="service" />
    </div>
    <div :class="$style.inner">
      <div
        v-if="$slots.duration"
        :class="$style.duration"
      >
        <slot name="duration" />
      </div>
      <div
        v-if="$slots.resources"
        :class="$style.resources"
      >
        <slot name="resources" />
      </div>
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { isSmallScreen } from '@/modules/calendar/appointment/helpers.ts';

const props = defineProps<{
  inPackage?: boolean;
}>();
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  width: 100%;
  gap: $spacing * 0.75;

  &:not(.smallScreen) {
    flex-direction: row;
  }

  &.smallScreen {
    &.inPackage {
      flex-direction: row;
    }

    &:not(.inPackage) {
      flex-direction: column;
    }
  }
}

.inner {
  display: flex;
  width: 60%;
  align-items: center;
  gap: $spacing;

  &:empty {
    display: none;
  }
}

.service {
  display: flex;
  align-items: center;
  gap: $spacing * 0.5;

  .base:not(.smallScreen) & {
    width: 40%;
  }

  .base.smallScreen & {
    flex-grow: 1;
    width: 100%;
    padding-right: $spacing * 3;
  }
}

.duration {
  flex-shrink: 0;

  .base.smallScreen.inPackage & {
    width: 100%;
  }

  .base:not(.smallScreen) & {
    width: 25%;
  }
}

.resources {
  display: flex;
  align-items: center;
  gap: $spacing * 0.5;
  flex-shrink: 0;
}
</style>
